import { QueryConfiguration } from '@nucleus/lib-dynamodb';
import { Stage } from './stage';
import { getTableName } from './utilities/tables';

export const ProfileTableName = getTableName('profile', 'NucleusPlatformResources', Stage);

export const ProfileTableKeys = {
  partkey: 'person_id',
  sortkey: 'owner_id',
  gsi1name: 'gsi_partkeyGlobalIndex',
  gsi1partkey: 'gsi_partkey',
  gsi1sortkey: 'gsi_sortkey',
} as const;

export type ProfileTablePrimaryKeys = {
  [ProfileTableKeys.partkey]: string;
  [ProfileTableKeys.sortkey]: string;
};

export type ProfileTableGsi1Keys = {
  [ProfileTableKeys.gsi1partkey]: string;
  [ProfileTableKeys.gsi1sortkey]: string;
};

export const ProfileTablePrimaryQueryConfig: QueryConfiguration = {
  partKey: ProfileTableKeys.partkey,
  sortKey: ProfileTableKeys.sortkey,
};

export const ProfileTableGsi1QueryConfig: QueryConfiguration = {
  name: ProfileTableKeys.gsi1name,
  partKey: ProfileTableKeys.gsi1partkey,
  sortKey: ProfileTableKeys.gsi1sortkey,
};
